import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import { $enum } from 'ts-enum-util'
import { ICertificationCode } from 'types/FMSGraphqlTypes'
import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../constants'

const CERTIFICATE_OPTION_VALUES = $enum(ICertificationCode).getValues()

export const CertificationSchema = yup.object({
  code: yup
    .mixed<ICertificationCode>()
    .oneOf(CERTIFICATE_OPTION_VALUES, REQUIRED_MESSAGE)
    .nullable()
    .required(REQUIRED_MESSAGE),
  issuingOrganization: yup.string().nullable(),
  renewalDate: yup.string().nullable(),
})

export type TCertificationSchema = yup.InferType<typeof CertificationSchema>

export const getErrorMessage = <T extends FieldErrors<TCertificationSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
